import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd, Event as NavigationEvent } from '@angular/router';
import { Location } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { CommonService } from 'src/app/shareModule/services/common.service';

@Component({
  selector: 'app-other-communty-page',
  templateUrl: './other-communty-page.component.html',
  styleUrls: ['./other-communty-page.component.scss']
})
export class OtherCommuntyPageComponent implements OnInit, OnDestroy {
  private scrollPosition: [number, number] = [0, 0];
  private destroy$ = new BehaviorSubject<void>(null);
  constructor(
    private router: Router,
    private location: Location,
    private commonService: CommonService,
    @Inject("WINDOW") private window: any,
  ) { }

  ngOnInit(): void {
    this.router.events.subscribe((event: NavigationEvent) => {
      if (event instanceof NavigationEnd) {
        this.window.scrollTo(this.scrollPosition[0], this.scrollPosition[1]);
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onNavigate(url) {
    this.scrollPosition = [this.window.scrollX, this.window.scrollY];
    this.router.navigate([`/${url}`]);
  }
  goBack() {
    this.commonService.goBack();
  }
}
